import { render, staticRenderFns } from "./teacherMatingDetailModule.vue?vue&type=template&id=00006f62&scoped=true"
import script from "./teacherMatingDetailModule.vue?vue&type=script&lang=js"
export * from "./teacherMatingDetailModule.vue?vue&type=script&lang=js"
import style0 from "./teacherMatingDetailModule.vue?vue&type=style&index=0&id=00006f62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00006f62",
  null
  
)

export default component.exports